<template>
  <div class="clm-ctrl-help" v-if="$i18n.locale=='ru'">
    <a href="tel:88002226595" class="clm-ctrl-help__btn clm-btn">
      <span class="clm-btn__text">
        {{ needHelp.title }}
      </span>
    </a>
  </div>

  <div class="clm-ctrl-help" v-else>
    <a href="tel:77172972409" class="clm-ctrl-help__btn clm-btn">
      <span class="clm-btn__text">
        7 (717) 297-24-09
      </span>
    </a>
  </div>

</template>

<script>

export default {
  name: "clm-ctrl-help",
  props: {
    needHelp: {
      type: Object
    }
  }
}
</script>


<style scoped>
.clm-ctrl-help .clm-ctrl-help__btn {
  width: 165px;
}
@media (max-width: 768px) {
  .clm-ctrl-help .clm-ctrl-help__btn {
    width: 145px;
  }
}
</style>
